import { typeOf } from '@ember/utils';

export enum StorageKey {
  DASHBOARD_CHECK_IN = 'dashboard-config-v2:check-in',
  DASHBOARD_CHECK_OUT = 'dashboard-config-v2:check-out',
  DASHBOARD_STAYS = 'dashboard-config-v2:stays',
  DASHBOARD_NEW_BOOKINGS = 'dashboard-config-v2:new-bookings',
  DASHBOARD_ENQUIRIES = 'dashboard-config-v2:enquiries',
  DASHBOARD_BOOKING_REQUESTS = 'dashboard-config-v2:booking-requests',
  DASHBOARD_PENDING = 'dashboard-config-v2:pending',
  DASHBOARD_CANCELLED = 'dashboard-config-v2:cancelled',
  DASHBOARD_BOOKING_PAYMENT = 'dashboard-config-v2:booking-payment',
  DASHBOARD_SECURITY_DEPOSITS = 'dashboard-config-v2:security-deposits',
  DASHBOARD_BOOKING_GUEST_IDENTITY_VERIFICATION = 'dashboard-config-v2:booking-guest-identity-verification',
  DASHBOARD_BOOKING_RENTAL_AGREEMENT = 'dashboard-config-v2:booking-rental-agreement',

  SMART_LOCKS_PRICING_CONFIRMATION = 'smart-locks-config:pricing-confirmed',

  MONTHLY_CALENDAR_ROWS = 'monthly-config:calendar-rows',

  ACTION_PERIOD = 'action-config:period',
  ACTION_FILTERS = 'action-config:event-types',
  ACTION_PROPERTIES = 'action-config:properties',
  ACTION_TASKS_VIEW = 'action-config:tasks-view',
  ACTION_TASKS_RANGE = 'action-config:tasks-range',
  ACTION_TASKS_FILTERS = 'action-config:tasks-filters',
  ACTION_TASKS_OVERDUE_OPEN = 'action-config:tasks-overdue-open',

  CALENDAR_WEEK_STARTS_ON = 'monthly-config:week-starts-on',

  CALENDAR_ROWS = 'calendar-config:rows',
  CALENDAR_INBOX_CHANNEL_TYPE = 'calendar-config:inbox:channel-type',
  CALENDAR_INBOX_TYPE = 'calendar-config:inbox:type',
  CALENDAR_INBOX_STARRED = 'calendar-config:inbox:starred',
  CALENDAR_INBOX_ARCHIVED = 'calendar-config:inbox:archived',
  CALENDAR_INBOX_ORDER = 'calendar-config:inbox:order',
  CALENDAR_INBOX_ASSIGNED_USER = 'calendar-config:inbox:assigned-user',

  CALENDAR_PICTURE_CONFIG = 'calendar-config:picture',
  CALENDAR_CHANGEOVER_CONFIG = 'calendar-config:changeover',
  CALENDAR_TASKS_CONFIG = 'calendar-config:tasks',
  CALENDAR_ENQUIRIES_CONFIG = 'calendar-config:enquiries',
  CALENDAR_EXPANDED_PROPERTIES = 'calendar-config:expanded-properties',
  CALENDAR_BOOKING_AMOUNT_CONFIG = 'calendar-config:booking-amount',

  LOCALE_PREFERENCE = 'locale-config:preference',
  SIDEBAR_PINNED = 'sidebar-config:pinned',

  // Written by the E2E harness (uplisting-dev/e2e) before app boot, read by
  // `app/services/feature-flags.ts` to force gates on/off per scenario.
  E2E_FEATURE_GATES = 'e2e:feature_gates',

  MAINTENANCE_BYPASS = 'maintenance-config:bypass',
}

export enum StorageType {
  local = 'local',
}

interface IStorageApi {
  get<T>(key: string): T | null;
  set<T>(key: string, value: T): void;
  remove(key: string): void;
}

class StoragesHandler {
  get [StorageType.local](): IStorageApi {
    return this.withStorage(window.localStorage);
  }

  withStorage(storage: Storage): IStorageApi {
    return {
      // @ts-expect-error - need to improve typings to make it work properly
      get: this.getSync.bind(storage),
      set: this.setSync.bind(storage),
      remove: this.removeSync.bind(storage),
    };
  }

  private getSync<T>(this: Storage, key: string): T | null {
    const item = this.getItem(key);

    if (item === null) {
      return null;
    }

    try {
      return JSON.parse(item) as T;
    } catch {
      return item as unknown as T;
    }
  }

  private setSync(this: Storage, key: string, _value: unknown): void {
    let value = _value;

    if (['array', 'object'].includes(typeOf(value))) {
      value = JSON.stringify(value);
    }

    return this.setItem(key, value as string);
  }

  private removeSync(this: Storage, key: string): void {
    return this.removeItem(key);
  }
}

export const storage = new StoragesHandler();
